import {RegexpValidator} from "./RegexpValidator";

export class NumberValidator extends RegexpValidator{

    protected getRegexp(): RegExp {
        return /^[0-9]+$/;
    }
}
